import React from 'react';
import { Box, Grid, HtmlTrans, Typography } from 'web-library';
import { TFunction } from 'react-i18next';

interface IUploadStateAndAction {
  classes: any;
  strings?: {
    instruction?: string;
    htmlInstruction?: string;
  };
  labels: {
    visualLabel: React.ReactElement;
    actionLabel?: React.ReactElement;
  };
}

const UploadStateAndAction = ({ classes, strings, labels }: IUploadStateAndAction) => (
  <Box className={classes.loadingSection}>
    {strings && strings.instruction && (
      <Typography variant="body1" className={classes.instruction}>
        {strings.instruction}
      </Typography>
    )}

    {strings && strings.htmlInstruction && (
      <Typography variant="body1" className={classes.instruction}>
        <HtmlTrans i18nKey={strings.htmlInstruction} />
      </Typography>
    )}

    <Grid alignItems="center" container>
      <Grid>{labels.visualLabel}</Grid>
      <Grid>{labels.actionLabel}</Grid>
    </Grid>
  </Box>
);

export default UploadStateAndAction;
